import React from 'react';

import s from '../../Carousel.scss';
import Modal from '../../../Modal/Modal';
import AppImage from '../../../Image/Image';

export type RenderModalProps = {
  handleOnModalClose?: () => void;
  largeImages?: string[];
  mainImages?: string[];
  modalImageIndex?: number | null;
  /**
   * react-modal requires that you pass in the unique className or unique id of
   * the current react application's root element. Failure to do so will result
   * in console errors and inconsistent behavior.  See react-modal docs for more
   * information.
   */
  setAppElement?: string | HTMLElement;
};

export const RenderModal = ({
  handleOnModalClose,
  largeImages = [],
  mainImages = [],
  modalImageIndex,
  setAppElement,
}: RenderModalProps) => {
  const src =
    typeof modalImageIndex === 'number' &&
    (largeImages?.[modalImageIndex] || mainImages?.[modalImageIndex]);

  if (src) {
    return (
      <Modal
        className={s.modal}
        contentLabel="Product Image Modal"
        data-testid="RenderModal"
        isOpen
        onModalClose={handleOnModalClose}
        setAppElement={setAppElement}
      >
        <AppImage className={s.modalImage} src={src} />
      </Modal>
    );
  }

  return null;
};

export default RenderModal;
